module.exports = __webpack_public_path__ + "static/Auto-Share-8-e1407759085655-74e56401e2fc29971a8a38e10d86738d.jpg";